// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-select-option-container {
  display: flex;
  flex-direction: row;
}

.session-select-option-text {
  display: flex;
  flex-direction: column;
}

.session-select-option-title {
  font-size: var(--font-size-m);
}

.session-select-option-subtext {
  font-size: var(--font-size-s);

  > svg {
    margin-right: var(--input-element-gap-small);
    margin-bottom: -1px;
  }
}

.session-select-option-date {
  font-size: var(--font-size-s);
}

.session-select-option-date > svg {
  margin-right: var(--input-element-gap-small);
  margin-bottom: -1px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/session-select/session-select-option/SessionSelectOption.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;;EAE7B;IACE,4CAA4C;IAC5C,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB","sourcesContent":[".session-select-option-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.session-select-option-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.session-select-option-title {\n  font-size: var(--font-size-m);\n}\n\n.session-select-option-subtext {\n  font-size: var(--font-size-s);\n\n  > svg {\n    margin-right: var(--input-element-gap-small);\n    margin-bottom: -1px;\n  }\n}\n\n.session-select-option-date {\n  font-size: var(--font-size-s);\n}\n\n.session-select-option-date > svg {\n  margin-right: var(--input-element-gap-small);\n  margin-bottom: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
